import { render, staticRenderFns } from "./WhistleblowerBlock.vue?vue&type=template&id=e0010020"
import script from "./WhistleblowerBlock.vue?vue&type=script&lang=js"
export * from "./WhistleblowerBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports